module.exports = {
    api: "https://app-dev.formulir.com/api/",
    baseUrl: 'https://dev.form.id',
    googleCaptchaKey: "8133ec97-b0eb-43fe-bbc4-710ea27745c5",
    imagekit:{
        thumbnail:"https://media.form.id/gcs/tr:n-ik_thumbnail",
        medium: "https://media.form.id/gcs/tr:n-ik_medium",
        full:"https://media.form.id/gcs/tr:n-ik_full/"      
    },
    shippingUrl:"https://research.mengantar.com/api/",
    webCacheURL: 'https://cache-dev.form.id',
    orderHmacSecret: "formulir2021",
};
